import React from "react";
import Autocomplete from "components/common_components/Autocomplete/Autocomplete";
import UserOption from "components/common_components/UserSelect/UserOption";

const AttorneySelect = ({ value, options, onChange }) => {
    return (
        <div className="item" style={{ width: "40%" }}>
            <b>Attorney</b>
            <Autocomplete
                value={value}
                options={options}
                valueKey="id"
                labelKey="name"
                onChange={onChange}
                label=""
                variant="standard"
                renderOption={(user) => <UserOption {...user} />}
                getOptionLabel={(option) => (option ? option.name : "")}
                getOptionSelected={(opt, val) => opt?.id === val?.id}
            />
        </div>
    );
};

export default AttorneySelect;
